import { render, staticRenderFns } from "./WorkflowDetail.vue?vue&type=template&id=5785b01a&"
import script from "./WorkflowDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports